module.exports = {"540236100":"加加镇","540236200":"昌果乡","540236201":"雄如乡","540236202":"拉藏乡","540236203":"如角乡","540236204":"达吉岭乡","540236205":"旦嘎乡","540236206":"夏如乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540236.json
// module id = 2703
// module chunks = 0